import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';
import { PayerTypeSchema } from '../contracts';

const UpdatePayerTypesRequestDtoSchema = z.object({
  facilityId: z.number(),
  productTypes: z.array(
    z.object({
      productTypeId: z.number(),
      payer: PayerTypeSchema.nullable(),
    })
  ),
});

const UpdatePayerTypesResponseDtoSchema = z.array(
  z.object({
    id: z.number(),
    facilityId: z.number(),
    isDisabled: z.boolean(),
    payer: PayerTypeSchema.nullable(),
    productTypeName: z.string(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
  })
);

export type UpdatePayerTypesRequestDto = z.infer<
  typeof UpdatePayerTypesRequestDtoSchema
>;
export type UpdatePayerTypesResponseDto = z.infer<
  typeof UpdatePayerTypesResponseDtoSchema
>;

export const updatePayerTypes = (
  dto: UpdatePayerTypesRequestDto,
  config?: AxiosRequestConfig<UpdatePayerTypesRequestDto>
) => {
  const { facilityId, ...data } = UpdatePayerTypesRequestDtoSchema.parse(dto);

  return api
    .patch(`/facilities/product-types/${facilityId}`, data, config)
    .then(responseContract(UpdatePayerTypesResponseDtoSchema));
};
